<template>

  <v-container
      class="fill-height"
      fluid
  >
    <v-row
        align="center"
        justify="center"
    >
      <v-col
          cols="12"
          sm="8"
          md="4"
      >

        <ValidationProvider ref="observer" v-slot="{ invalid, validated, passes, validate }">
          <v-card class="elevation-12">
            <v-toolbar
                color="primary"
                dark
                flat
            >
              <v-toolbar-title>{{ $t("Mis datos") }}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <ValidationProvider v-slot="{ errors }" rules="min:6">
                <v-text-field
                    id="password"
                    :label="$t('Cambiar Contraseña')"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="password"
                    :error-messages="errors"
                ></v-text-field>
                </ValidationProvider>
              </v-form>

              <v-radio-group v-model="lang">
                <v-radio
                    label="Catalan"
                    value="ca"
                ></v-radio>
                <v-radio
                    label="Español"
                    value="es"
                ></v-radio>
              </v-radio-group>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="submit" color="primary">{{ $t('Enviar') }}</v-btn>
            </v-card-actions>
          </v-card>
        </ValidationProvider>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>

import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';
import axios from "axios";

setInteractionMode('eager')

export default {
  name: "login",

  props: {
    source: String,
  },
  components: {
    ValidationProvider, ValidationObserver
  },
  data() {
    return {
      password: "",
      lang: "",

    }
  },
  methods: {
    submit() {
      this.$refs.observer.validate().then(success => {
        const config = {
          method: "PATCH",
          url: this.$store.state.endpoints.updateaccount,
          headers: {Authorization: "Bearer " + this.$store.state.jwt},
          data: {
            password: this.password,
            lang: this.lang,
          }
        };
        this.$store.commit("setLang", this.lang)
        axios(config)
            .then((response) => {
              this.$i18n.locale = this.$store.state.lang
              this.$store.commit("showMessage",{color:"green",content:this.$i18n.t("Guardado")})
            })
            .catch(error => {
              console.log(error)
            });
      })
    }
  },
  mounted() {
      // console.log("here")
      // console.log(this.$store.state)
      this.lang = this.$store.state.lang
    }

}

</script>
